import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=6c8cb08f"
import script from "./step1.vue?vue&type=script&lang=js"
export * from "./step1.vue?vue&type=script&lang=js"
import style0 from "./step1.vue?vue&type=style&index=0&id=6c8cb08f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports